const NAME = 'ORG_COMMENTS_INDEX';

export const REQUEST_COMMENTS = `${NAME}/REQUEST_COMMENTS`;
export const RECEIVE_COMMENTS = `${NAME}/RECEIVE_COMMENTS`;
export const COMMENTS_REQUEST_FAILED = `${NAME}/COMMENTS_REQUEST_FAILED`;
